export default __webpack_public_path__ + "static/media/indiakabttle.715fe2a4.png";